"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lang = require("lodash/lang"); // Create a DisplayedAdInfo object. This is a standardized set of info
// about an ad that's been shown.


var DisplayedAdInfo = function DisplayedAdInfo(_ref) {
  var adId = _ref.adId,
      _ref$revenue = _ref.revenue,
      revenue = _ref$revenue === void 0 ? null : _ref$revenue,
      _ref$encodedRevenue = _ref.encodedRevenue,
      encodedRevenue = _ref$encodedRevenue === void 0 ? null : _ref$encodedRevenue,
      GAMAdvertiserId = _ref.GAMAdvertiserId,
      GAMAdUnitId = _ref.GAMAdUnitId,
      adSize = _ref.adSize;

  if ((0, _lang.isNil)(adId)) {
    throw new Error('The "adId" value must be provided.');
  }

  if (typeof adId !== 'string') {
    throw new Error('The "adId" value must be a string.');
  }

  if ((0, _lang.isNil)(revenue) && (0, _lang.isNil)(encodedRevenue)) {
    throw new Error('A bid response must have either the "revenue" or "encodedRevenue" property.');
  }

  if (!(0, _lang.isNil)(revenue) && typeof revenue !== 'number') {
    throw new Error('The "revenue" value must be a number.');
  }

  if ((0, _lang.isNil)(GAMAdvertiserId)) {
    throw new Error('The "GAMAdvertiserId" value must be provided.');
  }

  if (!(0, _lang.isNil)(GAMAdvertiserId) && typeof GAMAdvertiserId !== 'number') {
    throw new Error('The "GAMAdvertiserId" value must be a number.');
  }

  if ((0, _lang.isNil)(GAMAdUnitId)) {
    throw new Error('The "GAMAdUnitId" value must be provided.');
  }

  if (typeof GAMAdUnitId !== 'string') {
    throw new Error('The "GAMAdUnitId" value must be a string.');
  }

  if ((0, _lang.isNil)(adSize)) {
    throw new Error('The "adSize" value must be provided.');
  }

  if (typeof adSize !== 'string') {
    throw new Error('The "adSize" value must be a string.');
  }

  return {
    adId: adId,
    revenue: revenue,
    // Float|null
    encodedRevenue: encodedRevenue,
    // String|null
    GAMAdvertiserId: GAMAdvertiserId,
    // Number|null
    GAMAdUnitId: GAMAdUnitId,
    // String, such as "/12345678/SlotName"
    adSize: adSize // String, such as "728x90"

  };
};

var _default = DisplayedAdInfo;
exports.default = _default;